import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';

interface IPasswordRulesProps {
  isCaracterNumberValid: boolean;
  isPasswordContainsLowercase: boolean;
  isPasswordContainsUppercase: boolean;
  isPasswordContainsNumber: boolean;
  isPasswordContainsSpecialChar: boolean;
  isCurrentPasswordRequired?: boolean;
  className?: string;
}

export function PasswordRules({
  isCaracterNumberValid,
  isPasswordContainsLowercase,
  isPasswordContainsUppercase,
  isPasswordContainsNumber,
  isPasswordContainsSpecialChar,
  isCurrentPasswordRequired = true,
  className,
}: IPasswordRulesProps) {
  const { t } = useTranslation();
  return (
    <div className={clsx('flex flex-col gap-3 text-helper typo-body-regular-caption', className)}>
      {!!isCurrentPasswordRequired && <span>{t('pages.auth.changePassword.rules.message')}</span>}
      <ul className="space-y-2 list-outside pl-3 [&>li]:pl-3">
        <li className={isCaracterNumberValid ? 'list-["✓"] text-success' : 'list-["•"]'}>
          {t('pages.auth.changePassword.rules.characters')}
        </li>
        <li className={isPasswordContainsLowercase ? 'list-["✓"] text-success' : 'list-["•"]'}>
          {t('pages.auth.changePassword.rules.lowercase')}
        </li>
        <li className={isPasswordContainsUppercase ? 'list-["✓"] text-success' : 'list-["•"]'}>
          {t('pages.auth.changePassword.rules.uppercase')}
        </li>
        <li className={isPasswordContainsNumber ? 'list-["✓"] text-success' : 'list-["•"]'}>
          {t('pages.auth.changePassword.rules.number')}
        </li>
        <li className={isPasswordContainsSpecialChar ? 'list-["✓"] text-success' : 'list-["•"]'}>
          {t('pages.auth.changePassword.rules.specialCharacter')}
        </li>
      </ul>
    </div>
  );
}

//'\2713\00a0'
